module.exports = __webpack_public_path__ + "img/sixpackcarrier55.471aad11.jpg";